<template>
    <div v-if="bloqueo==0">
        <v-row>
            <v-col cols="12" class="mt-10 text-center">
                <img src="@/assets/denegado.png" />
            </v-col>
        </v-row>
    </div>
    <div v-else>
        <v-container>
            <v-row class="mt-2">
                <v-col cols="3">
                    <v-radio-group class="mt-2" v-model="tipo" row>
                        <v-radio label="Producto" color="success" value="producto"></v-radio>
                        <v-radio label="Material" color="success" value="material"></v-radio>
                    </v-radio-group>
                </v-col>
                <v-col cols="2">
                    <v-text-field class='text-body-2' v-model="sku" label="Sku" outlined dense rounded disabled></v-text-field>
                </v-col>
                <v-col cols="4">
                    <v-text-field class='text-body-2' v-model="producto" label="Producto" outlined dense rounded disabled></v-text-field>
                </v-col>
                <v-col cols="1">
                    <v-btn @click="openProducts()" class="mt-1" small color="indigo" dark rounded><v-icon small>find_replace</v-icon></v-btn>
                </v-col>
                <v-col cols="2">
                    <v-text-field class='text-body-2' v-model="fecha" label="Fecha" outlined dense rounded disabled></v-text-field>
                </v-col>
            </v-row>
            <v-row class="mt-n7">
                <v-col cols="3">
                    <v-alert class='text-caption' dense shaped text type="info">
                        Selecciona Producto o Material !!!
                    </v-alert>
                </v-col >
                <v-col cols="2">
                    <v-text-field class='text-body-2' v-model="categoria" label="Categoria" outlined dense rounded disabled></v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-text-field class='text-body-2' v-model="marca" label="Marca" outlined dense rounded disabled></v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-text-field class='text-body-2' v-model="variante" label="Variante" outlined dense rounded disabled></v-text-field>
                </v-col>
            </v-row>
            <v-row class="mt-n7">
                <v-col cols="5">
                    <v-row>
                        <v-col cols="12">
                            <v-textarea class='text-body-2' no-resize rows="4" outlined dense rounded v-model="descripcion" label="Descripcion" disabled></v-textarea>                                
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="7">
                    <v-row class="mt-0">
                        <v-col cols="3">
                            <v-text-field class='text-body-2' v-model="medida" label="Medida" outlined dense rounded disabled></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field @keypress="onlyDecimal" class='text-body-2' v-model="barra" label="Cod. Barra" outlined dense rounded disabled></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field @keypress="onlyDecimal" class='text-body-2' v-model="precio" label="Precio Venta" outlined dense rounded disabled></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mt-n7">
                        <v-col cols="3">
                            <v-select class='text-body-2' v-model="movimiento" :items="listamovimiento" label="I / E" dense outlined rounded></v-select>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field @keypress="onlyDecimal" class='text-body-2' v-model="cantidad" label="Cantidad" outlined dense rounded></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field class='text-body-2' v-model="observa" label="Observacion" outlined dense rounded></v-text-field>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-container>
                <div>
                    <v-row>
                        <v-col cols="2" class="mt-n5 text-end">
                            <img src="" id="img1" height="150" width="150" style="border: 1px solid grey"/>
                        </v-col>
                        <v-col cols="2" class="mt-n5 text-end">
                            <img src="" id="img2" height="150" width="150" style="border: 1px solid grey"/>
                        </v-col>
                        <v-col cols="2" class="mt-n5 text-end">
                            <img src="" id="img3" height="150" width="150" style="border: 1px solid grey"/>
                        </v-col>
                        <v-col cols="2" class="mt-n5 text-end">
                            <img src="" id="img4" height="150" width="150" style="border: 1px solid grey"/>
                        </v-col>
                        <v-col cols="2" class="mt-n5 text-end">
                            <img src="" id="img5" height="150" width="150" style="border: 1px solid grey"/>
                        </v-col>
                        <v-col cols="2" class="mt-n5 text-end">
                            <img src="" id="img6" height="150" width="150" style="border: 1px solid grey"/>
                        </v-col>
                    </v-row>
                </div>
                <v-divider class="mt-4"></v-divider>
                <v-row class="mt-3">
                    <v-col cols="4"></v-col>
                    <v-col cols="2">
                        <v-btn @click="clsInput()" color="teal" rounded dark small block>Nuevo</v-btn>
                    </v-col>
                    <v-col cols="2">
                        <v-btn v-if="btn_grabar==true" @click="saveAjuste()" color="teal" small dark rounded block>Grabar</v-btn>
                        <v-btn v-else color="grey" small dark rounded block>Grabar</v-btn>
                    </v-col>
                    <v-col cols="4"></v-col>
                </v-row>
            </v-container>
        </v-container>
        <!-- lista de productos -->
        <v-dialog v-model="d_products" transition="dialog-bottom-transition" max-width="50%" persistent>
        <v-card>
            <v-card-title>
                <v-row>
                    <v-col cols="4" md="8">
                        <v-btn @click="d_products=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                        <strong class="ml-2 text-body-2">Productos</strong>
                    </v-col>
                    <v-col cols="8" md="4" class="text-end">
                        <v-text-field class='ml-5 mr-2 text-body-2' v-model="products_search" label="Buscar Producto" dense required></v-text-field>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-data-table @click:row="handleProductos" dense dark 
                    :search="products_search" :headers="products_titulo" :items="filter_products" 
                    :page.sync="products_page" :items-per-page="products_itemsPerPage"  
                    @page-count="products_pageCount = $event" hide-default-footer class="elevation-1 text-size">
                </v-data-table>
                <v-pagination v-model="products_page" :length="products_pageCount"></v-pagination>
            </v-card-text>
        </v-card>
        </v-dialog>

        <v-dialog v-model="loading" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Procesando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="snack" timeout="3000" :color="color_snack">
            <div class="d-flex justify-center">                
                <h4>{{mensaje}}</h4>
            </div>
        </v-snackbar>
    </div>
</template>
<style scoped>
.text-size >>> td {
    font-size: 9pt !important;
    height: 25px !important;
    /* background-color: lightyellow; */
}
.col-color >>> th {
    /* background-color: lightgrey; */
    background-color: lightblue;
}
form img{
  width: 150px;
  height: 150px;
  /* border-radius: 50%; */
  border: 2px solid #AAA;
}
form div:first-child{
  align-items: center;
}
</style>
<script>
import axios from "axios";
export default {
  name: 'Productos',
  data: () => ({
    contrato:null,
    user:null,
    apikey:null,

    snack:false,
    color_snack:'',
    mensaje:'',

    hoy:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
    fecha:'',
    sku:'',
    producto:'',
    tipo:'producto',
    categoria:'',
    marca:'',
    variante:'',
    descripcion:'',
    medida:'',
    barra:'',
    precio:'',
    cantidad:'',
    observa:'',
    listamovimiento:['Ingreso','Egreso'],
    movimiento:'',

    d_products:false,
    products_titulo: [
      { text: 'Sku', align: 'start', sortable: true, value: 'codigo' },
      { text: 'Producto', align: 'start', sortable: true, value: 'producto' },
      { text: 'Variante', align: 'start', sortable: true, value: 'variante' },
    ],
    products_lista: [],
    filter_products:[],
    products_page: 1,
    products_pageCount: 0,
    products_itemsPerPage: 1000000,
    products_search:'',
    numClicks:0,
    btn_grabar:true,
    bloqueo:null,
    loading:false,

  }),
  async mounted(){
    this.user=localStorage.getItem('user');
    this.apikey=localStorage.getItem('apiKey');
    this.contrato=localStorage.getItem('contrato');
    this.fecha=this.formatFecha(this.hoy);
    await this.searchProducts();
    this.bloqueo = await this.myPermiso(8);
  },
  methods:{
    async myPermiso(id){
        let result = 0;
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user : this.user,
                id : id
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                result = parseInt(datos[0].acceso);
            }
        } catch (error) {
            console.log(error)
        }
        return result
    },
    clsInput(){
        this.sku='';
        this.producto='';
        this.tipo='producto';
        this.categoria='';
        this.marca='';
        this.variante='';
        this.descripcion='';
        this.medida='';
        this.barra='';
        this.precio='';
        this.cantidad='';
        this.observa='';
        this.movimiento='';
        this.numClicks=0;
        this.btn_grabar=true;
        document.getElementById( 'img1' ).src = '';
        document.getElementById( 'img2' ).src = '';
        document.getElementById( 'img3' ).src = '';
        document.getElementById( 'img4' ).src = '';
        document.getElementById( 'img5' ).src = '';
        document.getElementById( 'img6' ).src = '';
    },
    formatFecha(fec){
      const dia = fec.substring(8,10);
      const mes = fec.substring(5,7);
      const anio = fec.substring(0,4);
      const hoy = dia + '-' + mes + '-' + anio;
      return hoy;
    },
    onlyDecimal ($event) {
        //console.log($event.keyCode); //keyCodes value
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // && keyCode !== 46 is dot
            $event.preventDefault();
        }
    },
    async searchProducts(){
        this.loading=true;
        try {
            this.products_lista=[];
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                sku :  'all'
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/products/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.products_lista=datos;
            }
        } catch (error) {
            console.log(error)
        }
        this.loading=false;
    },
    openProducts(){
        this.filter_products = this.products_lista.filter(res => res.tipo==this.tipo);
        this.d_products=true;
    },
    handleProductos(item){
        this.sku=item.codigo;
        this.producto=item.producto;
        this.categoria=item.categoria;
        this.marca=item.marca;
        this.variante=item.variante;
        this.descripcion=item.descripcion;
        this.medida=item.medida;
        this.barra=item.barra;
        this.precio=item.precio_detalle;
        document.getElementById( 'img1' ).src = item.img1;
        document.getElementById( 'img2' ).src = item.img2;
        document.getElementById( 'img3' ).src = item.img3;
        document.getElementById( 'img4' ).src = item.img4;
        document.getElementById( 'img5' ).src = item.img5;
        document.getElementById( 'img6' ).src = item.img6;
        this.d_products=false;
    },
    async saveAjuste(){
        this.loading=true;
        try {
            this.numClicks++;
            if(this.numClicks==1){
                //obtener el signo
                let signo = '';
                if(this.movimiento=='Ingreso') { signo = '0+' };
                if(this.movimiento=='Egreso') { signo = '0-' };
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                const params = {
                    contrato : this.contrato,
                    user: this.user,
                    fecha: this.hoy,
                    tipo: this.tipo,
                    codigo: this.sku,
                    cantidad: this.cantidad,
                    signo: signo,
                    usuario: this.user,
                    observa: this.observa,
                    origen: 'Ajuste'
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/adjust/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    this.color_snack='success';
                    this.mensaje='Ajuste grabado con exito';
                    this.snack=true
                    this.btn_grabar=false;
                } else {
                    this.color_snack='error';
                    this.mensaje='No es posible grabar el ajuste';
                    this.snack=true
                }
            } else {
                this.numClicks=0
            }
        } catch (error) {
            console.log(error)
            this.color_snack='error';
            this.mensaje='Algo salio mal, informar a soporte';
            this.snack=true
        }
        this.loading=false;
    }
  }
}
</script>
